import React from "react";
import {FilesPicker} from "../../../libs/components/FormControls";
import ImagePreviewer from "./ImagePreviewer";
import DragAndDrop from '../../../libs/HOCS/DragAndDrop';
import ImageFile from '../../../libs/models/ImageFile';

const styles = {
  container: {
    height: 300,
    overflow: "auto",
    border: "1px solid black"
    // display: "flex",
    // alignItems: "center",
    // justifyContent: "center"
  },
  item: {
    //todo change name - its not used per item but as an container
    display: "flex",
    flexWrap: "wrap",
    justifyContent: "center"
  },
  btn: {
    margin: 5,
    backgroundColor: "#2ecc71",
    borderWidth: 0,
    padding: 7,
    borderRadius: 2,
    transition: "background-color .3s",
    boxShadow: "0 1px 4px rgba(0, 0, 0, .6)",
    outline: "none",
    color: "#ecf0f1"
  }
};

export default function ImagesList({ 
  imageFiles, 
  onRemove, 
  onFilesSelected , 
  onDragCompleted
}){

  let refs = {};

  const getOrCreateRef = (refId) => {

    if(!refs[refId]){
      refs[refId] = React.createRef();
    }
    return refs[refId];

  }

  const processSeletctedFiles = (selectedFiles) => {
    const filesToPreview = [];
    const filesArray = Array.from(selectedFiles);

    filesArray.forEach((file) => {
      const fileToPreview = ImageFile(file.name,URL.createObjectURL(file),file);
      filesToPreview.push(fileToPreview);
    });

    return filesToPreview;

  };

  const selectAll = () => {

    Object.keys(refs).forEach(key => {
      if(refs[key]){
        refs[key].current.checked = true;
      }
    });

  };

  const unselectAll = () => {

    Object.keys(refs).forEach(key => {
      if(refs[key]){
        refs[key].current.checked = false;
      }
    });

  };
  
  const getSelectedFileIds = () => {
    
    let selectedIds = [];
    
    Object.keys(refs).forEach(key => {
      if(refs[key] && refs[key].current.checked){
        selectedIds.push(key);
      }
    });

    return selectedIds;
  }

  const removeFiles = () => {

    if(onRemove){
      const fileIdsToDelete = getSelectedFileIds();
      console.log('selected ids')
      console.log(fileIdsToDelete);
      const filesToRemove = imageFiles.filter(imageFile => fileIdsToDelete.includes(imageFile.key))
      console.log('files to remove')
      console.log(filesToRemove);
      onRemove(filesToRemove);
    }
    
  };

  const renderFile = (file, index) => {

    console.log('file')
    console.log(file)
    return (
      <ImagePreviewer
        index={index}
        imageUrl={file.url}
        key={file.key}
        id={file.filename}
        onDragCompleted={onDragCompleted}
        ref={getOrCreateRef(file.key)}
      />
    );

  };

  return (
    <div className="App">
      <DragAndDrop>
        <p>images:</p>
        <div style={styles.container}>
          {imageFiles ? (
            <div style={styles.item}>
              {imageFiles.map((f, i) => renderFile(f, i))}
            </div>
          ) : (
            "no images attached"
          )}
        </div>
      </DragAndDrop>
      <div style={{ padding: 15 }}>
        <button onClick={() => selectAll()}>select all</button>
        <button onClick={() => unselectAll()}>unselect all</button>
        <button onClick={() => removeFiles()}>remove</button>
        <FilesPicker
          onFilesSelceted={(selectedFiles) =>{
            if(onFilesSelected){
              const files = processSeletctedFiles(selectedFiles);
              onFilesSelected(files);
            }
          }}
        />
      </div>
    </div>
  );
}
